import queryString from 'query-string'
import _ from 'lodash'

export default function () {
  let payload = _.assign.apply(_, _.filter(arguments, argument => argument !== undefined))
  return queryString.stringify(payload, { encode: true, arrayFormat: 'bracket' })
}
